function showMenuToggle(){
    /*if($("body").width()<768)
        return showMobileMenuToggle();
    else*/
        return showPcMenuToogle();
}

function showPcMenuToogle(){
    if(!$("body").hasClass("show-map")) {

        $("li.opened-mobile", ".site-map").removeClass("opened-mobile");

        $("body").addClass("show-map");

        //return;

        if(! $( ".site-map .list" ).attr("data-menu-loaded")){
            $.get( "/_media/static/includes/menu/", function( data ) {
                $( ".site-map .list" ).html( data );
                $( ".site-map .list" ).attr("data-menu-loaded","true");
                setTimeout(function(){$("body").addClass("show-map-anim");},100);
            });
        }else{
            $("body").addClass("show-map-anim");
        }

        $("body").css({"padding-right": getScrollBarWidth()});
    }else {
        $("body").addClass("hide-map");
        window.setTimeout(function(){
            $("body").css({"padding-right": 0});
            $("body").removeClass("show-map");
            $("body").removeClass("show-map-anim");
            $("body").removeClass("hide-map");
        },300);
    }

    //$("body").toggleClass("show-map");
    return false;
}

function showMobileMenuToggle(){
    alert("Not so fast amigo (=")
    return false;
}